import React from 'react'
import classNames from 'classnames'
import { FieldProps } from 'formik'
import { FieldWrapper, ErrorHelp } from '.'

type Option = [number, string, string?]

type ButtonSelectProps = FieldProps & {
  label: string
  options: Option[]
  multiple?: boolean
  afterChange?: (val: any) => void
}

const ButtonSelect: React.FC<ButtonSelectProps> = ({
  label,
  field: { value, name },
  form: { setFieldValue, setFieldTouched, touched, errors },
  options,
  multiple,
  afterChange,
}) => {
  return (
    <FieldWrapper label={label} horizontal={false}>
      <div className="field">
        <div className="control">
          <div className="buttons">
            {options.map(([id, label, color]) => {
              const selected = multiple ? value.includes(id) : value == id

              return (
                <button
                  key={id}
                  type="button"
                  className={classNames(
                    'button',
                    {
                      'is-active': selected,
                      'is-info': selected && !color,
                      'is-light': color && !selected,
                    },
                    color ? 'is-' + color : ''
                  )}
                  onClick={async () => {
                    const val = multiple
                      ? selected
                        ? value.filter(item => item != id)
                        : [...value, id]
                      : id

                    setFieldValue(name, val)

                    setFieldTouched(name)

                    if (afterChange) {
                      afterChange(val)
                    }
                  }}
                >
                  {label}
                </button>
              )
            })}
          </div>
        </div>

        <ErrorHelp touched={touched} errors={errors} name={name} />
      </div>
    </FieldWrapper>
  )
}

export default ButtonSelect
